import React from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { useAddOneDayDataMutation } from "src/services/CourseServices";

import AddDayDetailsForm from "./AddDayDetailsForm";
import { AddDayDetailsFormValues } from "src/models/AddDayDetails.model";
import { showToast } from "src/utils/showToaster";

type Props = {
  selectDayData: any;
  planId: string;
};

const AddDayDetailsFormWrapper = ({ selectDayData, planId }: Props) => {
  const [addDaysData] = useAddOneDayDataMutation();

  // Form Initial Values
  const initialValues: AddDayDetailsFormValues = {
    notes: selectDayData?.notes || "",
    exampleAndScript: selectDayData?.exampleAndScript || "",
    resources: selectDayData?.resources?.[0] !== ''
      ? selectDayData?.resources?.map((el: any) => {
          return {
            name: el?.resourceName,
          };
        })
      : [
          {
            name: "",
          },
        ],
  };

  // Validation Schema
  const validationSchema = object().shape({
    notes: string().required("Please enter notes"),
    exampleAndScript: string().required("Please enter exampleAndScript"),
  });

  // Handle Submit
  const handleSubmit = (
    values: AddDayDetailsFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AddDayDetailsFormValues>
  ) => {
    const formattedValues = {
      notes: values?.notes,
      planId: planId,
      day: selectDayData?.day,
      remark: selectDayData?.remark,
      exampleAndScript: values?.exampleAndScript,
      resources: values?.resources?.map((el: any) => {
        return {
          resourceName: el?.name,
        };
      }),
    };
    addDaysData({
      dayId: selectDayData?._id,
      body: formattedValues,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form>
          <AddDayDetailsForm formikProps={formikProps} />
        </Form>
      )}
    </Formik>
  );
};

export default AddDayDetailsFormWrapper;
